import * as React from 'react'
import Box from '@mui/material/Box'
import LinearProgress from '@mui/material/LinearProgress'
import CircularProgress from '@mui/material/CircularProgress'
import { styled } from '@mui/material/styles'
import clsx from 'clsx'
import PropTypes from 'prop-types'

const PREFIX = 'LoadingStyles'
export const classes = {
  loadingContainer: `${PREFIX}-loadingContainer`,
  alignCircle: `${PREFIX}-alignCircle`
}

export const LoadingStyles = styled(Box)(({ theme }) => ({
  [`&.${classes.loadingContainer}`]: {
    height: '100vh',
    top: 0,
    left: 0,
    backgroundColor: theme.mode === 'dark' ? '#000000c9' : '#ffffffde',
    zIndex: 10
  },
  [`&.${classes.alignCircle}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
}))

const Loading = ({ type, open, position }) => {
  if (!open) {
    return null
  }
  return (
        <LoadingStyles
            sx={{ width: '100%' }}
            style={{ position }}
            className={clsx(
              classes.loadingContainer,
              { [classes.alignCircle]: type === 'circular' }
            )}
        >
            {type === 'linear' && <LinearProgress/>}
            {type === 'circular' && <CircularProgress />}
        </LoadingStyles>
  )
}
Loading.propTypes = {
  type: PropTypes.string,
  open: PropTypes.bool,
  position: PropTypes.string
}

Loading.defaultProps = {
  type: 'linear',
  open: false,
  position: 'fixed'
}

export default Loading
